import { DataService } from "./DataService";

export const DataAboutOne = {
  subTitle: "SETELEC SAS",
  title: "La société d’Energies, de Télécoms et de Constructions Industrielles",
  desc: "Elle est une entreprise de prestations de services spécialisée dans les domaines de l’électricité Haute et Basse Tensions (HTB/HTA/BTA), l’automatisme industriel, les Machines électriques, les Télécommunications, le Froid & Climatisation, la construction industrielle et la distribution de matériels industriel",
  img1: "assets/images/about/001.png",
  img2: "assets/images/about/003.png",
  img3: "assets/images/about/002.png",
};

export const DataAboutPageSec1 = {
  id: 1,
  subTitle: "SETELEC SAS",
  title: "La société d’Energies, de Télécoms et de Constructions Industrielles",
  desc: "par acronyme SETELEC SAS est un EPC (Engineering Procurement and Construction) qui intervient en Côte d’Ivoire et dans la sous-région Ouest Africaine. Son siège social est situé à Abidjan Angré 8e Tranche, Lot : 610, Ilot : 41. SETELEC SAS a été créée par un groupe d’Ingénieurs Ivoiriens pluridisciplinaires ayant une vingtaine d’années d’expérience tous experts dans leurs domaines. Elle est spécialisée dans les domaines de l’électricité haute et basse tensions, l’automatisme industriel, les Machines électriques, les Télécommunications, le Froid & Climatisation, la Plomberie, la Construction industrielle et la distribution de matériels industriels spécifiques. SETELEC SAS apporte aux sociétés du secteur de l’énergie, du Pétrole & Gaz, des mines, de l’agro-industrie, de téléphonie mobile et du BTP (Bâtiment et Travaux Publics) des solutions en ingénierie, travaux neufs, rénovation et maintenance.",
  img1: "assets/images/about/001.png",
  img2: "assets/images/about/003.png",
  img3: "assets/images/about/002.png",
};

export const DataAboutPageSec2 = {
  id: 1,
  title1: "Votre Partenaire Fiable et Expérimenté",
  desc: "Notre équipe est constituée d'Ingénieurs et de Techniciens expérimentés ayant en moyenne dix (10) années d’expérience. Ils ont fait leurs preuves dans de multinationales qui ont des standards élevés. Chez nous, le client est ROI, nous visons toujours sa satisfaction.",
  linkName: "En savoir plus",
  link: "/contact",
  img: "assets/images/about/about-large.jpg",
  title2: "Nos Engagements et Solutions",
  desc2:
    "SETELEC SAS apporte aux sociétés du secteur de l'énergie, du Pétrole & Gaz, des mines, de l'agro-industrie, de téléphonie mobile et du BTP des solutions complètes en ingénierie, travaux neufs, rénovation et maintenance, en respectant les standards internationaux.",
  linkName2: "Contactez-nous",
  link2: "/contact",
};

export const DataAboutPageSec3 = {
  littleText: "Fondée par des ** ingénieurs expérimentés. **",
  title: "Notre Expertise",
  subtitle: "Découvrez nos principaux domaines d'intervention",
  desc: "SETELEC SAS est spécialisée dans les domaines de l'électricité haute et basse tensions, l'automatisme industriel, les Machines électriques, les Télécommunications, le Froid & Climatisation, la Plomberie, la Construction industrielle et la distribution de matériels industriels spécifiques.",
  img: "assets/images/about/about-style-2.png",
  titleList: "Nos Départements",
  items: [
    {
      id: 1,
      title: DataService?.item1.title,
    },
    {
      id: 2,
      title: DataService?.item2.title,
    },
    {
      id: 3,
      title: DataService?.item3.title,
    },
    {
      id: 4,
      title: DataService?.item4.title,
    },
  ],
  CounterUp: 953,
  CounterDesc: "Opérations effectuées",
};

export const DataAboutServicePageSec3 = {
  title:
    "Les activités de l’entreprise sont organisées en quatre (04) grands Départements afin de mieux servir ses clients. Lesdits départements sont les suivants: ",
  subtitle: "",
  SymbolName: "",
  SymbolDesc: "",
  img: "assets/images/work/work-1.png",
  items: [
    {
      id: 1,
      delay: 250,
      title: DataService?.item1.title,
    },
    {
      id: 2,
      delay: 350,
      title: DataService?.item2.title,
    },
    {
      id: 3,
      delay: 450,
      title: DataService?.item3.title,
    },
    {
      id: 4,
      delay: 450,
      title: DataService?.item4.title,
    },
  ],
  desc: " ",
};
